import { Box } from "@mui/material";
import "../App.css";
import { useLocation } from "react-router-dom";

const PageWrapper = ({ children }) => {
  const { pathname } = useLocation();

  const getBackgroundColor = () => {
    switch (pathname) {
      case '/gallery':
        return 'rgb(0, 0, 0)';
      case '/rsvp':
        return '#000';
      default:
        return 'rgb(255, 255, 255)';
    }
  };

  return (
    <Box
      className="App"
      sx={{
        display: "flex",
        position: "relative",
        width: "100%",
        height: "100vh",
        justifyContent: "center",
        alignItems: "center",
        overflow: "hidden",
        background: getBackgroundColor(),
        transition: "background 0.6s cubic-bezier(0.22, 1, 0.36, 1)",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          borderRadius: 2,
          pointerEvents: "none",
          zIndex: 1,
          width: "100%",
          height: "100%",
        }}
      />

      <Box
        sx={{
          position: "absolute",
          width: "100%",
          height: "100%",
          maxWidth: "calc(100vh * 1.32)",
          display: "flex",
          alignItems: "end",
          zIndex: 2,
          overflow: "hidden",
          margin: "auto",
          userSelect: "none",
          WebkitUserDrag: "none",
          KhtmlUserDrag: "none",
          MozUserDrag: "none",
          OUserDrag: "none",
          userDrag: "none",
          WebkitTouchCallout: "none",
        }}
      >
        {children}
      </Box>
    </Box>
  );
};

export default PageWrapper;
